// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2oUqP","dragIcon":"SortableItem_dragIcon__3vy0e","disabled":"SortableItem_disabled__ss-0M"};